module.exports = __webpack_public_path__ + "static/media/Original Korean - Lonely Struggle introduction.bb4c9941.txt";